import React from "react";
import { Group, Progress, Stack, Text } from "@mantine/core";

type Props = {
    filledGuests: number;
    totalGuests: number;
    missingGuests: number;
    language: "en" | "da";
};

export default function RoomingProgressBar({
    filledGuests,
    totalGuests,
    missingGuests,
    language,
}: Props) {
    const percent = totalGuests > 0 ? Math.round((filledGuests / totalGuests) * 100) : 0;

    return (
        <Stack gap={4} maw={360}>
            <Group justify="space-between" gap="xs">
                <Text size="xs" fw={700}>
                    {language === "en" ? "Rooming list" : "Rooming list"}
                </Text>

                <Text size="xs" c={missingGuests > 0 ? "orange" : "green"} fw={700}>
                    {filledGuests}/{totalGuests}
                </Text>
            </Group>

            <Progress
                value={percent}
                color={missingGuests > 0 ? "orange" : "green"}
                radius="xl"
                size="sm"
            />

            <Text size="xs" c="dimmed">
                {missingGuests > 0
                    ? language === "en"
                        ? `${missingGuests} guests missing`
                        : `${missingGuests} gæster mangler`
                    : language === "en"
                        ? "All guests filled"
                        : "Alle gæster er udfyldt"}
            </Text>
        </Stack>
    );
}
